export default {
    inject: ['ModalStore'],
    data: function () {
        return {
            modal: null,
        };
    },
    created: function () {
        this.modal = this.ModalStore.methods.getModalController();
    },
}
